// extracted by mini-css-extract-plugin
export default {"mainContainer":"ForgotPassword_mainContainer__1q9fh","mainHeading":"ForgotPassword_mainHeading__7t35X"};